import React, { useEffect, useState } from 'react';
import { Clock, Users } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 30
  });
  const [spots, setSpots] = useState(394);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    // Slowly decrease spots to create urgency
    const spotsTimer = setInterval(() => {
      setSpots(prev => prev > 12 ? prev - Math.floor(Math.random() * 3) : prev);
    }, 45000);
    return () => {
      clearInterval(timer);
      clearInterval(spotsTimer);
    };
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  const progressPercentage = spots / 500 * 100;
  return <div className="bg-red-50 border border-red-200 rounded-xl p-5 my-6 text-center" data-id="element-123">
      <div className="flex items-center justify-center gap-2 text-red-600 font-bold mb-3" data-id="element-124">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-125" />
        <span data-id="element-126">L'OFFERTA SCADE TRA:</span>
      </div>

      <div className="flex justify-center gap-3 mb-5" data-id="element-127">
        <div className="bg-white border border-red-100 rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-128">
          <span className="text-2xl font-black text-gray-800" data-id="element-129">
            {formatTime(timeLeft.hours)}
          </span>
          <span className="text-xs text-gray-500 font-medium" data-id="element-130">ORE</span>
        </div>
        <div className="text-2xl font-black text-red-400 mt-2" data-id="element-131">:</div>
        <div className="bg-white border border-red-100 rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-132">
          <span className="text-2xl font-black text-gray-800" data-id="element-133">
            {formatTime(timeLeft.minutes)}
          </span>
          <span className="text-xs text-gray-500 font-medium" data-id="element-134">MIN</span>
        </div>
        <div className="text-2xl font-black text-red-400 mt-2" data-id="element-135">:</div>
        <div className="bg-white border border-red-100 rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-136">
          <span className="text-2xl font-black text-red-600" data-id="element-137">
            {formatTime(timeLeft.seconds)}
          </span>
          <span className="text-xs text-gray-500 font-medium" data-id="element-138">SEC</span>
        </div>
      </div>

      <div className="space-y-2" data-id="element-139">
        <div className="flex justify-between text-sm font-semibold text-gray-700" data-id="element-140">
          <span className="flex items-center gap-1" data-id="element-141">
            <Users className="w-4 h-4" data-id="element-142" /> Posti Rimanenti
          </span>
          <span className="text-red-600" data-id="element-143">{spots} / 500</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-144">
          <div className="bg-red-500 h-2.5 rounded-full transition-all duration-1000" style={{
          width: `${progressPercentage}%`
        }} data-id="element-145"></div>
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-146">
          Affrettati! I posti si stanno esaurendo velocemente.
        </p>
      </div>
    </div>;
}